import { WorksAtEdgePropsSchema, AffiliatedWithEdgePropsSchema, EmptyEdgePropsSchema, ResponsibleForDocumentsEdgePropsSchema } from '../../graph-schemas/edges/common';

export interface EdgePropConfig {
  key: string;
  label: string;
  type: 'text' | 'date' | 'number' | 'boolean' | 'select' | 'picklist';
  options?: string[];
  picklistName?: string;
}

export interface EdgeDefinition {
  type: string;
  schema: any;
  displayName: string;
  reverseDisplayName?: string;
  sourceTypes: string[];
  targetTypes: string[];
  props: EdgePropConfig[];
}

export const BASE_CRM_EDGES: Record<string, EdgeDefinition> = {
  WORKS_AT: {
    type: 'WORKS_AT',
    schema: WorksAtEdgePropsSchema,
    displayName: 'Works At',
    reverseDisplayName: 'Employs',
    sourceTypes: ['Person'],
    targetTypes: ['Organization'],
    props: [
      { key: 'title', label: 'Title', type: 'text' },
      { key: 'role', label: 'Role', type: 'select', options: ['employee', 'advisor', 'board_observer', 'board_director', 'board_chair', 'investor', 'consultant', 'other'] },
      { key: 'start_date', label: 'Start Date', type: 'date' },
      { key: 'end_date', label: 'End Date', type: 'date' },
      { key: 'is_primary', label: 'Primary', type: 'boolean' },
    ],
  },
  AFFILIATED_WITH: {
    type: 'AFFILIATED_WITH',
    schema: AffiliatedWithEdgePropsSchema,
    displayName: 'Affiliated With',
    reverseDisplayName: 'Has Affiliate',
    sourceTypes: ['Person'],
    targetTypes: ['Organization'],
    props: [
      { key: 'role', label: 'Role', type: 'picklist', picklistName: 'affiliation_role' },
      { key: 'title', label: 'Title', type: 'text' },
      { key: 'start_date', label: 'Start Date', type: 'date' },
      { key: 'end_date', label: 'End Date', type: 'date' },
      { key: 'notes', label: 'Notes', type: 'text' },
    ],
  },
  RESPONSIBLE_FOR_DOCUMENTS: {
    type: 'RESPONSIBLE_FOR_DOCUMENTS',
    schema: ResponsibleForDocumentsEdgePropsSchema,
    displayName: 'Sends Documents For',
    reverseDisplayName: 'Document Contact',
    sourceTypes: ['Person'],
    targetTypes: ['Organization'],
    props: [{ key: 'notes', label: 'Notes', type: 'text' }],
  },
  REPORTS_TO: {
    type: 'REPORTS_TO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Reports To',
    reverseDisplayName: 'Manages',
    sourceTypes: ['Person'],
    targetTypes: ['Person'],
    props: [],
  },
  RELATED_TO: {
    type: 'RELATED_TO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Related To',
    reverseDisplayName: 'Related To',
    sourceTypes: [
      'Activity',
      'Task',
      'Document',
      'Opportunity',
      'Campaign',
      'Event',
      'Deal',
      'Investment',
      'ExternalFund',
      'Vehicle',
      'FundraisingOpportunity',
      'Commitment',
      'InvestmentAccount',
      'CapitalCall',
      'Distribution',
      'Report',
    ],
    targetTypes: ['*'],
    props: [],
  },
  HAS_THREAD: {
    type: 'HAS_THREAD',
    schema: EmptyEdgePropsSchema,
    displayName: 'Has Thread',
    reverseDisplayName: 'Thread Of',
    sourceTypes: ['Activity'],
    targetTypes: ['Thread'],
    props: [],
  },
};
